
export default function EMNonITAssetController(
  $scope,
  $rootScope,
  confirmDialog,
  ssDialogService,
  loaderService,
  alerts,
  assetDataService,
  addAssetTypeDialog,
) {
  const vm = this;

  vm.canEdit = true;
  vm.canDelete = true;

  vm.handleEditAssetType = _handleEditAssetType;
  vm.handleDeleteAssetType = _handleDeleteAssetType;

  activate();
  initEventListeners();

  /** *****************************************
   * Private Methods
   */

  function activate() {
  }

  function initEventListeners() {
  }

  /** *****************************************
   * Event Handlers
   */

  function _handleEditAssetType($event) {
    assetDataService.getAssetType(vm.nonItAsset.customerAssetType.customerAssetTypeId).then((response) => {
      ssDialogService.dialogs.enterpriseModeling.addITAssetTypeDialog = ssDialogService.alert(
          addAssetTypeDialog.getOptions($event, {
            functionId: vm.function.functionId,
            assetType: response.data,
          })
        );
      ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.addITAssetTypeDialog);
    });
  }

  function _handleDeleteAssetType($event) {
    ssDialogService.dialogs.enterpriseModeling.confirmDeleteITAssetTypeDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Asset Type?',
        message: `Deleting the Asset Type might sever its existing association within BCP Blueprint
        or the Information Security Applications. Are you sure you want to delete the Asset
        Type "${vm.nonItAsset.customerAssetType.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.confirmDeleteITAssetTypeDialog);
  }

  function _handleCancelDelete() {
    _closeDeleteAssetTypeDialog();
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return assetDataService.deleteAssetType(vm.nonItAsset.customerAssetType.customerAssetTypeId).then(() => {
      alerts.success(`The Asset Type "${vm.nonItAsset.customerAssetType.name}" has successfully been deleted.`);
      $rootScope.$broadcast('refreshFunctionNonITAssets', {
        functionId: vm.function.functionId,
        customerAssetTypeId: -1,
      });
      _closeDeleteAssetTypeDialog();
    })
    .catch(() => {
      alerts.error('An error occurred while deleting the Asset Type.');
    })
    .finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _closeDeleteAssetTypeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.confirmDeleteITAssetTypeDialog);
  }
}

EMNonITAssetController.$inject = [
  '$scope',
  '$rootScope',
  'confirmDialog',
  'ssDialogService',
  'loaderService',
  'alerts',
  'assetDataService',
  'addAssetTypeDialog',
];
